import { idpSlice } from './slices';
import type { UefatvOptions, UefatvState } from './types';

import { getOptionsProvider } from '@shared/OptionsProvider';
import { zustandStoreFactory } from '@shared/zustandStoreFactory';

export const { Provider: UefatvProvider, useStore: useUefatvStore } = zustandStoreFactory<UefatvState>(
  (...args) => ({
    ...idpSlice(...args),
  }),
  'UEFATV',
);

export const { OptionsProvider: UefatvOptionsProvider, useOptions: useUefatvOptions } =
  getOptionsProvider<UefatvOptions>();
